import gql from 'graphql-tag';

import type { UtilityContext } from '@change/core/react/utilityContext';

import type { GammaDeleteMediaHitMutation, GammaDeleteMediaHitMutationVariables } from './index.graphql';

export async function deleteMediaHit(
	mediaId: string,
	utilityContext: UtilityContext,
): Promise<GammaDeleteMediaHitMutation | null | undefined> {
	const {
		gql: { fetch },
	} = utilityContext;

	const { data } = await fetch<GammaDeleteMediaHitMutation, GammaDeleteMediaHitMutationVariables>({
		query: gql`
			mutation GammaDeleteMediaHit($input: DeleteCommentInput!) {
				deleteComment(input: $input) {
					success
					reason
				}
			}
		`,
		variables: {
			input: {
				commentId: mediaId,
			},
		},
	});
	return data;
}
